export default __webpack_public_path__ + "static/media/chevron-down.a4518251.svg";